@let errorInfo = this.errorInfo();
@if (this.isIdPError()) {
  @if (errorInfo?.code !== "login_required") {
    <h1>Authentication Error</h1>

    <p>
      The application reported an error during the authentication and login
      process.
    </p>
  } @else {
    <h1>Login Required</h1>

    <p>
      Your session has expired or you are not logged in. Please log in to
      continue.
    </p>
  }
} @else {
  <h1>Error</h1>

  <p>
    An unexpected application error occurred. We apologize for the
    inconvenience.
  </p>
}

@if (errorInfo) {
  @if (errorInfo.code === "login_required") {
    <button mat-flat-button (click)="this.handleLoginClick($event)">
      Login
    </button>
  } @else {
    <p class="description idp-error">
      {{ errorInfo.description }}
    </p>
  }
} @else {
  <p class="description">
    Please try again later. If the problem persists, please contact support.
  </p>
}
